import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=46d63fb2&scoped=true&"
var script = {}
import style0 from "./Update.vue?vue&type=style&index=0&id=46d63fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d63fb2",
  null
  
)

export default component.exports